// Button.tsx

import { twMerge } from "tailwind-merge";
type Variant = "primary" | "secondary" | "ghost" | "gradient";
type Size = "sm" | "md" | "lg";

type ButtonProps = {
  children: React.ReactNode;
  type?: "button" | "submit" | "reset";
  variant?: Variant;
  size?: Size;
  disabled?: boolean;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  id?: string;
};

const Button = ({
  children,
  type = "button",
  variant = "primary",
  size = "md",
  disabled = false,
  className = "",
  onClick,
  id,
}: ButtonProps) => {
  const base =
    "inline-flex items-center justify-center rounded-lg font-medium transition-colors duration-150 ";

  const variants: Record<Variant, string> = {
    primary: "bg-[#0079FF] text-white   disabled:bg-gray-300 disabled:text-gray-600",
    secondary:
      "bg-white text-black border border-gray-300 hover:bg-gray-50  disabled:bg-gray-100 disabled:text-gray-400",
    ghost: "bg-transparent text-black hover:bg-black/5  disabled:text-gray-400",
    gradient: `
    border-[3px] border-transparent
    bg-origin-border bg-clip-padding bg-clip-border
    bg-[linear-gradient(white,white),linear-gradient(90deg,#0079FF_0%,#00FF44_56.09%,#FFC400_100%)]
    text-black
    hover:bg-[linear-gradient(#f9fafb,#f9fafb),linear-gradient(90deg,#0079FF,#00FF44,#FFC400)]
    disabled:bg-[linear-gradient(#f3f4f6,#f3f4f6),linear-gradient(90deg,#d1d5db,#d1d5db)]
    disabled:text-gray-400
    `,
  };

  const sizes: Record<Size, string> = {
    sm: "h-14 px-3  text-[20px]",
    md: "h-14 px-4  min-w-[260px]  text-[20px]",
    lg: "h-18 px-6 text-base",
  };

  return (
    <button
      id={id}
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={twMerge(base, variants[variant], sizes[size], className)}
    >
      {children}
    </button>
  );
};

export default Button;
